import ComparisonAuditsBlock from "../../components/personal/ComparisonAuditsPage/ComparisonAuditsBlock";
import MainNavbar from "../../components/reuse/MainNavbar";
import PersonDropdown from "../../components/reuse/PersonDropdown";
import { TypicalPageStructure } from "../../components/reuse/TypicalPageStructure";

const ComparisonAuditsPage = () => {
    return(
        <>
        <TypicalPageStructure pageLabel={"Страница сравнения аудитов"}>
            <ComparisonAuditsBlock/>
        </TypicalPageStructure>
        </>
    )
}

export default ComparisonAuditsPage;